/**
 * Egy kép Promise-alapú betöltése.
 * @param src - A kép elérési útja.
 */
export default function preloadImage (src: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new window.Image()

    img.addEventListener('load', () => {
      resolve(src)
    })

    img.addEventListener('error', () => {
      reject(src)
    })

    img.src = src
  })
}
